import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-200 border-t border-background-300/40">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500/20 border border-primary-500/30">
                <i className="ri-moon-line text-lg text-primary-400"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-50 tracking-wider">
                邪娠娼馆
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              暗黑情色文学世界观完全指南。深入探索角色命运、剧情脉络与创作理念，为你揭示这部独特作品的全部魅力。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-foreground-200 mb-4 uppercase tracking-wider">
              内容分类
            </h4>
            <div className="space-y-2.5">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  <i className={`${cat.icon} mr-2 text-xs`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-foreground-200 mb-4 uppercase tracking-wider">
              关于本站
            </h4>
            <div className="space-y-2.5">
              <Link
                to="/about"
                className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                <i className="ri-information-line mr-2 text-xs"></i>
                关于我们
              </Link>
              <Link
                to="/about"
                className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2 text-xs"></i>
                联系我们
              </Link>
              <Link
                to="/about"
                className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                <i className="ri-shield-check-line mr-2 text-xs"></i>
                内容声明
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-300/30">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 邪娠娼馆世界观指南. 本站为粉丝自建内容分析平台，与原作者及出版方无商业关联。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap"
              rel="nofollow"
            >
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}